export default {
    getItem(key, def = null, decode = false) {
        let value = User.getFromStorage(key) ? User.getFromStorage(key) : def
        if (decode) {
            try {
                return JSON.parse(value)
            } catch (e) {
                return def
            }
        }
        return value
    },
    setItem(key, value) {
        User.putIntoStorage(key, value)
    },
}
